var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 128,
    height: 128,
    transform: "translate(1104 6784)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(-1104 -6784)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-2",
    "data-name": "color",
    transform: "translate(1101.5 6782.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14163",
    "data-name": "Path 14163",
    d: "M59.2,40.878h3.736m-1.978,1.978V38.9",
    transform: "translate(66.715 40.244)",
    fill: "none",
    stroke: "#f16723",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14164",
    "data-name": "Path 14164",
    d: "M25.2,7.278h3.956M27.178,9.036V5.3",
    transform: "translate(25.991)",
    fill: "none",
    stroke: "#4d9ad4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3293",
    "data-name": "Ellipse 3293",
    cx: 1.758,
    cy: 1.758,
    r: 1.758,
    transform: "translate(3.5 88.595)",
    fill: "none",
    stroke: "#f16723",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3294",
    "data-name": "Ellipse 3294",
    cx: 0.659,
    cy: 0.659,
    r: 0.659,
    transform: "translate(123.497 122.22)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3295",
    "data-name": "Ellipse 3295",
    cx: 0.659,
    cy: 0.659,
    r: 0.659,
    transform: "translate(7.016 82.002)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3296",
    "data-name": "Ellipse 3296",
    cx: 0.659,
    cy: 0.659,
    r: 0.659,
    transform: "translate(15.148 13.432)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3297",
    "data-name": "Ellipse 3297",
    cx: 0.659,
    cy: 0.659,
    r: 0.659,
    transform: "translate(116.684 37.607)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3298",
    "data-name": "Ellipse 3298",
    cx: 0.879,
    cy: 0.879,
    r: 0.879,
    transform: "translate(112.509 38.266)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3299",
    "data-name": "Ellipse 3299",
    cx: 2.198,
    cy: 2.198,
    r: 2.198,
    transform: "translate(89.432 21.344)",
    fill: "none",
    stroke: "#fbd108",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14165",
    "data-name": "Path 14165",
    d: "M8.3,61.458A21.667,21.667,0,0,1,30.058,39.7H96.21a21.758,21.758,0,1,1,0,43.515H30.058A21.667,21.667,0,0,1,8.3,61.458Z",
    transform: "translate(5.749 41.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14166",
    "data-name": "Path 14166",
    d: "M8.5,62.439V60.022A18.1,18.1,0,0,1,26.522,42h73.625a18.1,18.1,0,0,1,18.022,18.022A20.4,20.4,0,0,1,97.729,80.461H26.522A18.1,18.1,0,0,1,8.5,62.439Z",
    transform: "translate(5.989 43.958)",
    fill: "#5bb947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14167",
    "data-name": "Path 14167",
    d: "M8.5,57.824A15.758,15.758,0,0,1,24.324,42h77.8a15.824,15.824,0,0,1,0,31.648H24.544A15.946,15.946,0,0,1,8.5,57.824Z",
    transform: "translate(5.989 43.958)",
    fill: "#80c244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14168",
    "data-name": "Path 14168",
    d: "M44.883,39.7H30.158a21.758,21.758,0,1,0,0,43.515H44.883Z",
    transform: "translate(5.869 41.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14169",
    "data-name": "Path 14169",
    d: "M44.643,42H27.94a19.34,19.34,0,1,0,0,38.68h16.7Z",
    transform: "translate(6.109 43.958)",
    fill: "#e7d0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14170",
    "data-name": "Path 14170",
    d: "M44.523,42h-20a15.824,15.824,0,0,0,0,31.648h20Z",
    transform: "translate(6.228 43.958)",
    fill: "#ffe4b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14171",
    "data-name": "Path 14171",
    d: "M8.3,61.458A21.667,21.667,0,0,1,30.058,39.7H96.21a21.758,21.758,0,1,1,0,43.515H30.058A21.667,21.667,0,0,1,8.3,61.458ZM45,83.215v-40",
    transform: "translate(5.749 41.203)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3300",
    "data-name": "Ellipse 3300",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(29.214 97.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3301",
    "data-name": "Ellipse 3301",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(29.214 97.386)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14172",
    "data-name": "Path 14172",
    d: "M87.1,50.913A6.847,6.847,0,0,0,80.287,44.1m-3.3,0H75.452m-38.461,0H28.2",
    transform: "translate(29.584 46.473)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14173",
    "data-name": "Path 14173",
    d: "M9.892,82.878c-4.615-10.989.879-23.736,12.088-28.351L83.3,29.692A21.793,21.793,0,0,1,99.56,70.131L38.243,94.965A21.609,21.609,0,0,1,9.892,82.878Z",
    transform: "translate(5.696 27.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14174",
    "data-name": "Path 14174",
    d: "M11.225,84.55l-1.1-2.637a17.8,17.8,0,0,1,9.89-23.3l68.57-27.692a17.8,17.8,0,0,1,23.3,9.89,20.983,20.983,0,0,1-11.428,27.032L34.521,94.44a17.8,17.8,0,0,1-23.3-9.89Z",
    transform: "translate(6.341 29.099)",
    fill: "#ef5224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14175",
    "data-name": "Path 14175",
    d: "M9.734,80.423a15.867,15.867,0,0,1,8.791-20.659l72.306-29.23A15.876,15.876,0,0,1,102.7,59.984L30.393,89.214A15.867,15.867,0,0,1,9.734,80.423Z",
    transform: "translate(6.074 28.831)",
    fill: "#f16723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14176",
    "data-name": "Path 14176",
    d: "M35.656,37.6,22.03,43.094A21.793,21.793,0,1,0,38.293,83.533l13.626-5.494L35.656,37.6Z",
    transform: "translate(5.865 38.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14177",
    "data-name": "Path 14177",
    d: "M36.722,39.7,21.337,45.854A19.419,19.419,0,0,0,10.568,71.128,19,19,0,0,0,35.623,81.677l15.384-6.154Z",
    transform: "translate(6.778 41.203)",
    fill: "#e7d0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14178",
    "data-name": "Path 14178",
    d: "M37.306,39.7,18.625,47.172a15.876,15.876,0,0,0,11.868,29.45L49.174,69.15,37.306,39.7Z",
    transform: "translate(6.193 41.203)",
    fill: "#ffe4b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14179",
    "data-name": "Path 14179",
    d: "M9.892,82.878c-4.615-10.989.879-23.736,12.088-28.351L83.3,29.692A21.793,21.793,0,0,1,99.56,70.131L38.243,94.965A21.609,21.609,0,0,1,9.892,82.878Zm42.2,6.593L37.144,52.329",
    transform: "translate(5.696 27.255)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3302",
    "data-name": "Ellipse 3302",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(27.663 99.749) rotate(-21.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3303",
    "data-name": "Ellipse 3303",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(27.663 99.749) rotate(-21.998)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14180",
    "data-name": "Path 14180",
    d: "M82.761,35.591a6.723,6.723,0,0,0-8.791-3.736m-3.3,1.319-1.319.659m-35.6,14.285L25.4,51.635",
    transform: "translate(26.231 31.246)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14181",
    "data-name": "Path 14181",
    d: "M14.7,102.084a21.622,21.622,0,0,1,0-30.769L61.3,24.5A21.757,21.757,0,0,1,92.064,55.272L45.472,102.084a21.623,21.623,0,0,1-30.769,0Z",
    transform: "translate(5.719 15.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14182",
    "data-name": "Path 14182",
    d: "M16.213,103.294l-1.538-1.538a18.306,18.306,0,0,1,0-25.714L66.542,24.175a18.306,18.306,0,0,1,25.714,0,20.428,20.428,0,0,1,0,28.791L41.927,103.294a18.306,18.306,0,0,1-25.714,0Z",
    transform: "translate(7.067 16.289)",
    fill: "#f9ae19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14183",
    "data-name": "Path 14183",
    d: "M13.615,100.6a15.918,15.918,0,0,1,0-22.417L68.779,23.015A15.851,15.851,0,0,1,91.2,45.432L36.032,100.6a15.531,15.531,0,0,1-22.417,0Z",
    transform: "translate(6.588 15.691)",
    fill: "#fbd108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14184",
    "data-name": "Path 14184",
    d: "M25.133,37.4,14.8,47.729A21.757,21.757,0,0,0,45.572,78.5L55.9,68.169Z",
    transform: "translate(5.839 38.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14185",
    "data-name": "Path 14185",
    d: "M27.122,39.1,15.254,50.968A19.27,19.27,0,0,0,42.506,78.22L54.374,66.352Z",
    transform: "translate(7.366 40.484)",
    fill: "#e7d0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14186",
    "data-name": "Path 14186",
    d: "M27.781,39.1,13.715,53.166A15.851,15.851,0,0,0,36.132,75.583L50.2,61.517,27.781,39.1Z",
    transform: "translate(6.707 40.484)",
    fill: "#ffe4b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14187",
    "data-name": "Path 14187",
    d: "M14.7,102.084a21.622,21.622,0,0,1,0-30.769L61.3,24.5A21.757,21.757,0,0,1,92.064,55.272L45.472,102.084a21.623,21.623,0,0,1-30.769,0ZM56.021,91.535,27.89,63.184",
    transform: "translate(5.719 15.301)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3304",
    "data-name": "Ellipse 3304",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 27.412, 102.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3305",
    "data-name": "Ellipse 3305",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 27.412, 102.818)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14188",
    "data-name": "Path 14188",
    d: "M67.992,22.578a6.633,6.633,0,0,0-9.45,0M55.9,25.215l-1.1,1.1M27.773,53.347,21.4,59.72",
    transform: "translate(21.44 18.326)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14189",
    "data-name": "Path 14189",
    d: "M21.778,114.846A21.826,21.826,0,0,1,9.91,86.275l25.274-61.1a21.876,21.876,0,0,1,40.439,16.7L50.349,103.2A21.909,21.909,0,0,1,21.778,114.846Z",
    transform: "translate(5.678 7.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14190",
    "data-name": "Path 14190",
    d: "M23.123,115.351l-1.758-.659a18.351,18.351,0,0,1-9.89-23.955L39.387,23.265a18.351,18.351,0,0,1,23.956-9.89A20.223,20.223,0,0,1,74.331,39.748L46.859,105.461a18.107,18.107,0,0,1-23.736,9.89Z",
    transform: "translate(7.849 7.968)",
    fill: "#ed3c7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14191",
    "data-name": "Path 14191",
    d: "M19.423,114.068a16.01,16.01,0,0,1-8.571-20.879L40.741,21.323A15.959,15.959,0,0,1,70.191,33.63L40.3,105.5A15.828,15.828,0,0,1,19.423,114.068Z",
    transform: "translate(7.373 7.493)",
    fill: "#ef5e87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14192",
    "data-name": "Path 14192",
    d: "M15.624,39.4,9.91,53.026a21.876,21.876,0,0,0,40.439,16.7L56.063,56.1Z",
    transform: "translate(5.678 40.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14193",
    "data-name": "Path 14193",
    d: "M18.1,40.2,11.722,55.584a19.306,19.306,0,0,0,35.6,14.945L53.7,55.145,18.1,40.2Z",
    transform: "translate(8.042 41.802)",
    fill: "#e7d0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14194",
    "data-name": "Path 14194",
    d: "M18.644,40.2,10.951,58.661A15.959,15.959,0,1,0,40.4,70.969l7.692-18.461L18.644,40.2Z",
    transform: "translate(7.493 41.802)",
    fill: "#ffe4b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14195",
    "data-name": "Path 14195",
    d: "M21.778,114.846A21.826,21.826,0,0,1,9.91,86.275l25.274-61.1a21.876,21.876,0,0,1,40.439,16.7L50.349,103.2A21.909,21.909,0,0,1,21.778,114.846ZM56.063,89.352,19.14,73.968",
    transform: "translate(5.678 7.594)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3306",
    "data-name": "Ellipse 3306",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(28.364 106.337) rotate(-67.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3307",
    "data-name": "Ellipse 3307",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(28.364 106.337) rotate(-67.487)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14196",
    "data-name": "Path 14196",
    d: "M45.791,14.755A6.8,6.8,0,0,0,37,18.491m-1.319,3.077-.659,1.538M20.516,58.49,17,66.842",
    transform: "translate(16.17 10.764)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14197",
    "data-name": "Path 14197",
    d: "M30.058,119.268A21.667,21.667,0,0,1,8.3,97.51V31.358a21.758,21.758,0,1,1,43.516,0V97.51A21.667,21.667,0,0,1,30.058,119.268Z",
    transform: "translate(5.749 5.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14198",
    "data-name": "Path 14198",
    d: "M29.94,118.848A19.182,19.182,0,0,1,10.6,99.728V28.52a19.231,19.231,0,0,1,38.461.22V99.947a19.089,19.089,0,0,1-19.12,18.9Z",
    transform: "translate(8.504 4.911)",
    fill: "#3768a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14199",
    "data-name": "Path 14199",
    d: "M26.424,118.848A15.758,15.758,0,0,1,10.6,103.024v-77.8a15.824,15.824,0,0,1,31.648,0v77.8A15.621,15.621,0,0,1,26.424,118.848Z",
    transform: "translate(8.504 4.911)",
    fill: "#4d9ad4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14200",
    "data-name": "Path 14200",
    d: "M8.3,42.8V57.525a21.758,21.758,0,1,0,43.516,0V42.8Z",
    transform: "translate(5.749 44.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14201",
    "data-name": "Path 14201",
    d: "M10.6,42.8V59.5a19.34,19.34,0,0,0,38.68,0V42.8Z",
    transform: "translate(8.504 44.916)",
    fill: "#e7d0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14202",
    "data-name": "Path 14202",
    d: "M10.6,42.8v20a15.824,15.824,0,1,0,31.648,0v-20H10.6Z",
    transform: "translate(8.504 44.916)",
    fill: "#ffe4b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14203",
    "data-name": "Path 14203",
    d: "M51.816,48.061V97.51a21.758,21.758,0,1,1-43.516,0v-42.2M51.816,41.028v3.516M8.3,51.357v-20a21.758,21.758,0,0,1,43.516,0v6.154m0,45.054h-40",
    transform: "translate(5.749 5.15)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3308",
    "data-name": "Ellipse 3308",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(30.532 98.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3309",
    "data-name": "Ellipse 3309",
    cx: 5.275,
    cy: 5.275,
    r: 5.275,
    transform: "translate(30.532 98.704)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14204",
    "data-name": "Path 14204",
    d: "M19.513,12.7A6.847,6.847,0,0,0,12.7,19.513m.22,3.516v1.538m0,38.241V71.82",
    transform: "translate(11.019 8.863)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.5a002a73e98736baa04bf615af763814.svg";
export { ForwardRef as ReactComponent };